<template>
    <v-flex fill fill-height horizontal>
        <div class="text-xs-center" v-if="loading">
            <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
            ></v-progress-circular>
        </div>
        <div v-else class="header-section">
            <v-container fluid grid-list-md>
                <v-layout row wrap>
                    <v-flex xs8>
                        <h1>Player Management</h1>
                    </v-flex>
                    <v-flex xs4 text-xs-right>
                        <v-btn dark small color="indigo" @click.stop="dialog = true">
                            <v-icon dark>add</v-icon>
                            New Player
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
        <section v-if="!loading" class="elevation-1">
            <div v-sticky="stickyConfig" style="background:white" class="table-header-section">
                <v-data-table ref="headerTable" :headers="headers" :items="[]" hide-actions disable-initial-sort dense></v-data-table>
            </div>
            <v-data-table
                    :headers="headers"
                    :items="players"
                    hide-actions
                    ref="dataTable"
                    class="division-table"
                    dense
            >
                <template slot="items" slot-scope="props">
                    <tr @click="edit(props.item)">
                        <td>{{props.item.player_id}}</td>
                        <td>{{props.item.name}}</td>
                        <td>{{props.item.aliases}}</td>
                    </tr>
                </template>
            </v-data-table>
        </section>
        <v-dialog
                v-model="dialog"
                max-width="500"
        >
            <v-card>
                <v-card-title class="headline">Edit Player</v-card-title>

                <v-card-text>
                    <v-form>
                        <v-container>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-text-field
                                            v-model="selectedPlayer.name"
                                            :counter="50"
                                            label="Name"
                                            required
                                    ></v-text-field>
                                </v-flex>
                                <v-flex>
                                    <v-combobox
                                            v-model="selectedPlayer.aliases"
                                            chips
                                            multiple
                                            label="Aliases"
                                    ></v-combobox>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            color="red darken-1"
                            flat="flat"
                            @click="resetForm()"
                    >
                        Cancel
                    </v-btn>

                    <v-btn
                            color="green darken-1"
                            flat="flat"
                            @click="savePlayer()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-flex>
</template>

<script>
  import VueSticky from 'vue-sticky';
  export default {
    name: "PlayerManagement",
    directives: {
      'sticky': VueSticky
    },
    data() {
      return {
        headers: [
          { text: 'Id', value: 'player_id' },
          { text: 'Name', value: 'name' },
          { text: 'Aliases', value: 'aliases' }
        ],
        stickyConfig: {
          zIndex: 1,
          stickyTop: 64,
          disabled: false
        },
        error: null,
        loading: false,
        dialog: false,
        players: [],
        selectedPlayer: null
      }
    },
    methods: {
      async init () {
        this.generateNewRound();
        this.adjustOffset();
        await this.fetchData();
      },
      async fetchData () {
        this.error = null;
        this.players = [];
        this.loading = true;
        try {
          const raw = await this.$apiClient.players();
          this.players = raw.data;
        } catch (e) {
          this.error = e;
        }

        this.loading = false;
      },
      generateNewRound () {
        this.selectedPlayer = {
          player_id: -1,
          name: null,
          aliases: []
        };
        this.dialog = false;
      },
      async savePlayer() {
        if (this.selectedPlayer.player_id === -1) {
          await this.$apiClient.createPlayer(this.selectedPlayer);
        } else {
          await this.$apiClient.updatePlayer(this.selectedPlayer);
        }

        this.init();
      },
      edit(item) {
        this.selectedPlayer = Object.assign({}, item);
        this.dialog = true;
      },
      adjustOffset() {
        this.stickyConfig.stickyTop = ['xs', 'sm'].indexOf(this.$vuetify.breakpoint.name) > -1 ?  48 : 64;
      }
    },
    watch: {
      '$route': 'init',
      '$vuetify.breakpoint' : 'adjustOffset'
    },
    created() {
      this.init();
    }
  }
</script>

<style scoped>

</style>
